import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import PriceLabel from '@components/PriceLabel';

import { useIsDualPrice } from '../../hooks/useIsDualPrice';

import { BottomDiscountPart } from './BottomDiscountPart';
import { useVoucherDiscountContext } from './context';
import { messages } from './messages';
import { Wrapper, CurrencyWrapper, Slash } from './styled';
import { VoucherDiscountInfo } from './VoucherDiscountInfo';

export interface IVoucherDiscount {
  displayType: 'DiscountedPrice' | 'Percentage';
  percentage: number;
  discountedPrice: number;
  code: string;
  productsOnSaleIncluded: boolean;
  percentageFromMinimal: number | undefined;
  tags?: string[];
}

export interface IVoucherDiscountProps {
  voucherDiscount: IVoucherDiscount;
}

export const VoucherDiscount = ({ voucherDiscount }: IVoucherDiscountProps) => {
  const { currency } = useVoucherDiscountContext();
  const {
    isDualPrice,
    getLeftSideFormattedPrice,
    leftSideCurrency,
    rightSideCurrency,
    getRightSidePrice,
  } = useIsDualPrice();

  const {
    code,
    discountedPrice,
    productsOnSaleIncluded,
    percentage,
    percentageFromMinimal,
  } = voucherDiscount;

  return (
    <VoucherDiscountInfo
      showIcon={true}
      discountCode={code}
      instructionsText={<FormattedMessage {...messages.codeInCart} />}
      highlightedDiscountAmount={
        <>
          {isDualPrice && (
            <Wrapper>
              {getLeftSideFormattedPrice(discountedPrice)}{' '}
              <CurrencyWrapper>{leftSideCurrency}</CurrencyWrapper>
              <Slash>/</Slash>
            </Wrapper>
          )}
          <PriceLabel
            price={{
              value: isDualPrice
                ? getRightSidePrice(discountedPrice)
                : discountedPrice,
              currency: currency.code,
            }}
            wrapperComponent={Wrapper}
            currencyComponent={CurrencyWrapper}
            currencySymbolOverride={isDualPrice ? rightSideCurrency : undefined}
          />
        </>
      }
      bottomSection={
        <BottomDiscountPart
          legalText={
            productsOnSaleIncluded ? undefined : (
              <FormattedMessage {...messages.conditionText} />
            )
          }
          discountedPrice={discountedPrice}
          percentage={percentage}
          percentageFromMinimal={percentageFromMinimal ?? 0}
        />
      }
    />
  );
};
